import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';
import { useSnackbar } from 'notistack';
import { FC, useState } from 'react';
import { ManyImagesUploadDragDrop } from '../../../../../components';

interface ISalesContractImagesProps {
  image?: string;
  imageTitle: string;
  imageData(value): void;
  uploadText?: string;
  fileUrl?: string;
}

export const SalesContractImages: FC<ISalesContractImagesProps> = ({
  image,
  imageTitle,
  imageData,
  uploadText
}) => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [isUploading, setUploading] = useState(false);
  const [fileName, setFileName] = useState('');
  const [uploadedFile, setUploadedFile] = useState<string | null>(null);

  return (
    <>
      <Box className={classes.photosContainer}>
        <ManyImagesUploadDragDrop
          fileType={'.pdf'}
          imageTitle={imageTitle}
          isRequired={false}
          isDisabled={isUploading}
          isLoading={isUploading}
          imageKey={'optionImage'}
          uploadText={uploadText ?? 'Upload Document'}
          handleFileChange={async (images: any[], files: File[]) => {
            try {
              setUploading(true);

              const firstItem = files[0];
              setFileName(firstItem.name);

              const fileUrl = URL.createObjectURL(firstItem);
              setUploadedFile(fileUrl);

              imageData(firstItem);
            } catch (error) {
              enqueueSnackbar(error?.Detail ?? 'Error uploading document, please try again.', {
                variant: 'error'
              });
            } finally {
              setUploading(false);
            }
          }}
          images={[]}
          uploadedFile={uploadedFile}
          fileName={fileName}
        />
      </Box>
    </>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  photosContainer: {
    display: 'flex',
    marginTop: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column'
    },
    '@media print': {
      display: 'block'
    }
  }
}));
